class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  getCartNotification() {
    return document.querySelector('vh-cart-notification');
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();

    let cartNotification = this.getCartNotification();

    if (cartNotification && typeof cartNotification.setActiveElement !== 'function') {
      await customElements.whenDefined('vh-cart-notification');
      cartNotification = this.getCartNotification();
    }

    if (
      !cartNotification ||
      typeof cartNotification.setActiveElement !== 'function' ||
      typeof cartNotification.getSectionsToRender !== 'function' ||
      typeof cartNotification.renderContents !== 'function'
    ) {
      console.error('Van Horn cart notification is not ready.');
      return;
    }

    cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
